import { render } from "./OnDemandRechargeModal.vue?vue&type=template&id=4664d5dc&scoped=true"
import script from "./OnDemandRechargeModal.vue?vue&type=script&lang=js"
export * from "./OnDemandRechargeModal.vue?vue&type=script&lang=js"

import "./OnDemandRechargeModal.vue?vue&type=style&index=0&id=4664d5dc&lang=scss&scoped=true"
import "./OnDemandRechargeModal.vue?vue&type=style&index=1&id=4664d5dc&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4664d5dc"]])

export default __exports__